import {
  DialogContentText,
  Grid,
  Divider,
  List,
  ListItemText,
  ListItemButton,
  Button,
  Box,
  CircularProgress,
  Tooltip
} from '@mui/material';
import { formatSecondsToMinutes } from '../utils/functions';
import { PropTypes } from 'prop-types';
import { LYFT_COUNTDOWN_TOKEN_TO_PROGRESS } from '../utils/constants';
import { LyftRideType } from '../utils/LyftRide';
import CountdownTimer from './CountdownTimer';

function LyftRidesList({
  ridesList,
  handleListItemClick,
  requestRideButton, 
  rideSelectedIndex, 
  handleSendRideRequest, 
  searchRideByInterval,
  progress
}) {
  
  return(
    <Grid container item xs={4}>
      <Grid item xs={12}>
        {
          ridesList?.cost_estimates && <Box className='border-2 border-solid border-yellow rounded p-2'>
            <Box className='flex items-center justify-between mb-2'>
              <DialogContentText id="lyftDialog-cost-option" className='break-words font-bold'>
                Select ride option:
              </DialogContentText>
              <CountdownTimer 
                progress={progress}
                label={Math.round(progress/LYFT_COUNTDOWN_TOKEN_TO_PROGRESS)}
              />
            </Box>
            <List component="nav" className='max-h-60 overflow-auto'>
              {
                ridesList.cost_estimates.map((ride, index) => (
                  <Box key={index}>
                    <Tooltip title={LyftRideType[ride.ride_type]} placement='left-start' arrow>
                      <ListItemButton
                        selected={rideSelectedIndex === index }
                        onClick={(event) => handleListItemClick(event, index)}
                        className='py-0'
                      >
                        <ListItemText
                          primary={`Ride Type: ${ride.display_name}`}
                          secondary={
                            <span>
                              <b>Estimated Cost:</b> ${ride.upfront_cost_cents/100}<br/><b>Estimated Arrival:</b> {formatSecondsToMinutes(ride?.arrival_estimate?.duration)}
                            </span>
                          }
                        />
                      </ListItemButton>
                    </Tooltip>
                    <Divider/>
                  </Box>
                ))
              }
            </List>
          </Box>
        }
      </Grid>
      <Grid container item xs={12} direction="row-reverse">
        <Grid item xs={6} className='mt-auto'>
          {
            requestRideButton ? 
              <Button type="submit" variant="contained" fullWidth className='button green mt-2' onClick={handleSendRideRequest}>
                Request ride
              </Button>
            : 
              <Button type="submit" variant="contained" fullWidth className='button red mt-2' onClick={searchRideByInterval}>
                Search ride
              </Button>
          }
        </Grid>
      </Grid>
    </Grid>
  )
}

LyftRidesList.propTypes = {
  ridesList: PropTypes.object,
  handleListItemClick: PropTypes.func,
  requestRideButton: PropTypes.bool,
  rideSelectedIndex: PropTypes.number,
  handleSendRideRequest: PropTypes.func,
  searchRideByInterval: PropTypes.func
}

export default LyftRidesList;